var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cog",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M6.344,16.3a.406.406,0,0,1-.1-.013,8.206,8.206,0,0,1-2.114-.873.413.413,0,0,1-.153-.553,1.65,1.65,0,0,0-2.238-2.238.413.413,0,0,1-.553-.153,8.218,8.218,0,0,1-.873-2.114.412.412,0,0,1,.268-.493A1.648,1.648,0,0,0,1.7,8.3,1.647,1.647,0,0,0,.577,6.734a.412.412,0,0,1-.268-.493,8.206,8.206,0,0,1,.873-2.114.413.413,0,0,1,.553-.153A1.65,1.65,0,0,0,3.973,1.736a.413.413,0,0,1,.153-.553A8.218,8.218,0,0,1,6.241.309a.412.412,0,0,1,.493.268A1.648,1.648,0,0,0,8.3,1.7,1.647,1.647,0,0,0,9.859.577a.413.413,0,0,1,.493-.268,8.206,8.206,0,0,1,2.114.873.413.413,0,0,1,.153.553,1.65,1.65,0,0,0,2.238,2.238.413.413,0,0,1,.553.153,8.218,8.218,0,0,1,.873,2.114.412.412,0,0,1-.268.493,1.648,1.648,0,0,0,0,3.125.412.412,0,0,1,.268.493,8.206,8.206,0,0,1-.873,2.114.413.413,0,0,1-.553.153,1.65,1.65,0,0,0-2.238,2.238.413.413,0,0,1-.153.553,8.218,8.218,0,0,1-2.114.873.412.412,0,0,1-.493-.268,1.648,1.648,0,0,0-3.125,0,.414.414,0,0,1-.391.281ZM8.3,14.068a2.474,2.474,0,0,1,2.189,1.321,7.436,7.436,0,0,0,1.245-.513,2.475,2.475,0,0,1,3.146-3.146,7.339,7.339,0,0,0,.513-1.245,2.474,2.474,0,0,1,0-4.378,7.436,7.436,0,0,0-.513-1.245,2.475,2.475,0,0,1-3.146-3.146A7.339,7.339,0,0,0,10.486,1.2,2.472,2.472,0,0,1,8.3,2.524,2.473,2.473,0,0,1,6.108,1.2a7.367,7.367,0,0,0-1.245.513A2.475,2.475,0,0,1,1.717,4.862,7.339,7.339,0,0,0,1.2,6.107,2.472,2.472,0,0,1,2.525,8.3,2.473,2.473,0,0,1,1.2,10.485a7.367,7.367,0,0,0,.513,1.245,2.475,2.475,0,0,1,3.146,3.146,7.339,7.339,0,0,0,1.245.513A2.472,2.472,0,0,1,8.3,14.068Z",
    transform: "translate(-0.296 -0.297)",
    fill: "#0e0748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M9.473,11.947a2.473,2.473,0,1,1,2.473-2.473A2.477,2.477,0,0,1,9.473,11.947Zm0-4.122a1.649,1.649,0,1,0,1.649,1.649A1.651,1.651,0,0,0,9.473,7.824Z",
    transform: "translate(-1.472 -1.473)",
    fill: "#0e0748"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.80123b0760baf16b10603e810f12ec90.svg";
export { ForwardRef as ReactComponent };